import type { OnboardingStepId } from '@/types';

export type OnboardingStepDefinition = {
  id: OnboardingStepId;
  label: string;
  path: string;
};

/** Ordered onboarding wizard steps — paths match /setup/:step */
export const ONBOARDING_STEPS: OnboardingStepDefinition[] = [
  { id: 'account', label: 'Account', path: 'account' },
  { id: 'salesforce-login', label: 'Salesforce Login', path: 'salesforce-login' },
  { id: 'discover-org', label: 'Discover Org', path: 'discover-org' },
  { id: 'authentication', label: 'Authentication', path: 'authentication' },
  { id: 'call-center', label: 'Call Center', path: 'call-center' },
  { id: 'queue', label: 'Queue', path: 'queue' },
  { id: 'voice-flow', label: 'Voice Flow', path: 'voice-flow' },
  { id: 'telephony-provider', label: 'Telephony Provider', path: 'telephony-provider' },
  { id: 'credentials', label: 'Credentials', path: 'credentials' },
  { id: 'phone-numbers', label: 'Phone Numbers', path: 'phone-numbers' },
  { id: 'assign-agents', label: 'Assign Agents', path: 'assign-agents' },
  { id: 'validate', label: 'Validate', path: 'validate' },
  { id: 'go-live', label: 'Go Live', path: 'go-live' },
];

export const ONBOARDING_STEP_PATHS = ONBOARDING_STEPS.map((s) => s.path);

export const DEFAULT_ONBOARDING_STEP = ONBOARDING_STEPS[0].path;

export function isValidOnboardingStep(step: string): step is string {
  return ONBOARDING_STEP_PATHS.includes(step);
}

export function getOnboardingStepIndex(step: string): number {
  return ONBOARDING_STEP_PATHS.indexOf(step);
}
